import lenisScroll from './module/lenisScroll.js'
import menuMobile from './module/menuMobile.js'
import scrollMarkers from './module/scrollMarkers.js'
import initGsap from './module/gsap.js'
import modal from './module/modal.js'
// import initVtModal from './module/vt-modal.js'

// import accordion from './module/accordion.js'
import cookies from './module/cookies.js'
// import filters from './module/filters.js'
// import darkModeOS from './module/darkModeOS.js'
import animations from './module/animations.js'
// import contactForm from './module/contactForm.js'
import preventZoom from './module/preventZoom.js'
import alertRotateDevice from './module/alertRotateDevice.js'
// import tabs from './module/tabs.js'
import customRellax from './module/customRellax.js';
// import getUrlParams from './module/getUrlParams.js';

// function functions (deviceData) { // Only One Param if not using Barba.js
function functions ( deviceData ) {
  // console.log(deviceData);
  lenisScroll()
  customRellax()
  menuMobile(deviceData)
  scrollMarkers(deviceData)
  // darkModeOS(cookies)
  animations()
  initGsap()  
  modal()
  preventZoom()
  alertRotateDevice(deviceData.isDesktop, deviceData.isBigTablet, deviceData.isMobile)
}

export default functions
